import { apiFetch, ApiError } from '@/lib/api';

type GetToken = () => Promise<string | null>;

export type ProExportSection =
  | 'messages'
  | 'accounting'
  | 'calendar'
  | 'check_ins'
  | 'exchange'
  | 'journal'
  | 'expense_disputes'
  | 'hearing_prep';

const SECTION_FILENAMES: Record<string, string> = {
  accounting: 'expenses-payments-export.csv',
  messages: 'messages-export.pdf',
  calendar: 'custody-calendar-export.pdf',
  check_ins: 'check-ins-export.pdf',
  exchange: 'parenting-time-compliance-report.pdf',
  journal: 'journal-export.pdf',
  expense_disputes: 'expense-dispute-summary.pdf',
  hearing_prep: 'hearing-prep-brief.pdf',
};

/**
 * Download a single PDF or CSV (accounting) for a professional client invite.
 * Lawyer-report analytics (`Compliance Report Downloaded`, etc.) are tracked
 * server-side on the export/pdf endpoint with `solo_household` when available.
 */
export async function downloadProfessionalSectionExport(
  getToken: GetToken,
  inviteId: number,
  section: string,
  _options?: { soloHousehold?: boolean }
): Promise<void> {
  const isCsv = section === 'accounting';
  const qs = new URLSearchParams({ section });
  const res = await apiFetch(
    getToken,
    `/v1/professional/clients/${inviteId}/export/pdf?${qs.toString()}`,
    {
      auth: true,
      headers: { Accept: isCsv ? 'text/csv,*/*' : 'application/pdf,*/*' },
    }
  );
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new ApiError(`Export failed: ${res.status}`, res.status, text);
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = SECTION_FILENAMES[section] ?? `${section}-export.pdf`;
  a.click();
  URL.revokeObjectURL(url);
}
